import GeospatialMapLayerType from "./geospatialMapLayerType";

export default class GeospatialMapLayer {
  public idGeospatialMapLayer: number = 0;
  public idMapLayer: number = 0;
  public layerType: GeospatialMapLayerType = GeospatialMapLayerType.XyzTiles;
  public layerUrl: string = "";
}
